import React, { useContext, useState, useEffect, createContext } from "react";
import { db } from "./firebase";
const APIContext = createContext();

export function DataContext({ children }) {
  const [players, setPlayers] = useState([]);
  const [winners, setWinners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    function fetchData() {
      db.members
        .orderBy("ign")
        .get()
        .then((q) => {
          let gusers = [];
          q.docs.forEach((x) => {
            gusers.push(x.data());
          });

          setPlayers(gusers);
          setIsLoading(false);
        });
      db.winners
        .orderBy("date", "desc")
        .get()
        .then((q) => {
          let temp = [];
          q.docs.forEach((winner) => {
            temp.push(winner.data());
          });

          setWinners(temp);
        });
    }
    fetchData();
  }, []);
  return (
    <APIContext.Provider
      value={{
        players,
        isLoading,
        winners,
      }}
    >
      {children}
    </APIContext.Provider>
  );
}

export function usePlayers() {
  const context = useContext(APIContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}
